import { IDevice } from "@hulanbv/platformapp";
import { CrudService } from "nest-utilities-client";
import { environment } from "../../constants/environment.constants";
import { httpService } from "../common/http.service";

class Service extends CrudService<IDevice> {
  constructor() {
    super([environment.apiUrl, "devices"].join("/"), httpService);
  }
}

export const deviceService = new Service();
